// AddressSelect Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Select from '../../../common/form/select/select.jsx'
import util from '../../../lib/util.jsx'

class AddressSelect extends Component {
  constructor (props) {
    super(props)

    this.state = {
      addressOptions: props.addressOptions ? props.addressOptions : [],
      address: props.address ? props.address : null,
      addressId: props.address ? props.address.type.toLowerCase() : '',
      dataDate: null
    }
  }

  static get propTypes () {
    return {
      addressOptions: PropTypes.array,
      address: PropTypes.object,
      onSelectAddress: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      addressOptions: [],
      address: null,
      onSelectAddress: null
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (
      nextProps.address !== this.props.address &&
      nextProps.address &&
      nextProps.address.type
    ) {
      this.setState({
        address: nextProps.address,
        addressId: nextProps.address.type.toLowerCase()
      })
    }

    if (nextProps.addressOptions !== this.props.addressOptions) {
      this.setState({ addressOptions: nextProps.addressOptions })
    }
  }

  render () {
    const address = this.state.address
    const country =
      address && address.country
        ? util.getCountriesFromCode(address.country)
        : ''
    return (
      <div className='address-select'>
        <div className='select-drop'>
          <Select
            options={this.state.addressOptions}
            name='addressId'
            className='form-dropdown'
            label='common.list.labelType'
            value={this.state.addressId}
            onChange={this._onChangeInput.bind(this, 'addressId')}
          />
        </div>
        {address && (
          <div className='viewinfo'>
            {address.street && <span className='item'>{address.street},</span>}
            {(address.city || address.postcode) && (
              <span className='item'>
                {address.postcode} {address.city},
              </span>
            )}
            {address.state && <span className='item'>{address.state},</span>}
            {address.country && <span className='item'>{country}</span>}
          </div>
        )}
      </div>
    )
  }

  /* Event Handlers */
  _onChangeInput (name, value) {
    this.setState({ [name]: value })

    if (this.props.onSelectAddress) {
      this.props.onSelectAddress(value)
    }
  }
}

export default AddressSelect
